import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { Mail, Phone, MapPin, Globe, ArrowUpRight } from "lucide-react";
import API from "@/lib/api";

// SVG paths for the supported social platforms (keys are lowercased platform names).
const SOCIAL_PATHS = {
  facebook:
    "M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z",
  instagram:
    "M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 100 12.324 6.162 6.162 0 000-12.324zM12 16a4 4 0 110-8 4 4 0 010 8zm6.406-11.845a1.44 1.44 0 100 2.881 1.44 1.44 0 000-2.881z",
  youtube:
    "M23.498 6.186a3.016 3.016 0 00-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 00.502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 002.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 002.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z",
  linkedin:
    "M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433a2.062 2.062 0 01-2.063-2.065 2.064 2.064 0 112.063 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z",
  whatsapp:
    "M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z",
  x: "M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z",
  twitter:
    "M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z",
};

const FALLBACK = {
  brand: {
    logo_url: "/ngxp.gif",
    logo_alt: "NGXP Technologies",
    description:
      "Engineering self-evolving intelligence systems for complex enterprise operations — connecting AI, real-time data, IoT, simulation, digital twins, XR, and AI-native enterprise platforms.",
    office_label: "Registered Office",
    office_address: [
      "15/122 A, Valiyaveetil, Valloppilly Road,",
      "Kolottimoola, Kalamassery,",
      "Ernakulam, Kerala, India - 682021",
    ],
    cta_label: "Start a Strategic Discussion",
    cta_link: "/contact#contact-form",
  },
  explore: {
    heading: "Explore",
    links: [
      { to: "/", label: "Home" },
      { to: "/about", label: "About Us" },
      { to: "/services", label: "Services" },
      { to: "/industries", label: "Industries" },
      { to: "/blogs", label: "Blogs" },
      { to: "/contact", label: "Contact" },
    ],
  },
  contact: {
    heading: "Get in Touch",
    addresses: [
      "BB Arcade, Millumpadi Road, Nest Road, Near NEST Techpark, Kakkanad, Kochi, Kerala, India 682042",
      "Technopark Kollam, SBC No: 5, 1st Floor, Ashtamudi Building, Kundara, Kollam, Kerala, India 691501",
    ],
    email: "info@ngxptechnologies.com",
    phone: "+91 9941630848, +91 9962647558",
    website_label: "www.ngxptechnologies.com",
    website_link: "https://www.ngxptechnologies.com",
  },
  bottom: {
    seal_image: "/duns-registered-seal.png",
    seal_link:
      "https://dunsregistered.dnb.com/DunsRegisteredProfileAnywhere.aspx?Key1=3204678&PaArea=Email",
    seal_alt: "D&B D-U-N-S Registered — NGXP TECHNOLOGIES LLP",
    copyright: "© {year} NGXP TECHNOLOGIES LLP. All rights reserved.",
    tagline: "Engineering self-evolving intelligence systems.",
    socials: [
      { platform: "Facebook", href: "https://www.facebook.com/ngxptechnologies" },
      { platform: "Instagram", href: "https://www.instagram.com/ngxptechnologies" },
      { platform: "YouTube", href: "https://www.youtube.com/@ngxptechnologies" },
      { platform: "LinkedIn", href: "https://www.linkedin.com/company/ngxp-technologies" },
      {
        platform: "WhatsApp",
        href: "https://wa.me/919941630848?text=Hi%20NGXP%20Technologies%20Team%2C%0A%0AI%20am%20interested%20in%20learning%20more%20about%20your%20services.%20Specifically%2C%20I%20would%20like%20more%20information%20on%3A%0A%0A-%20AI-native%20enterprise%20platforms%0A-%20Operational%20command%20centers%0A-%20Digital%20twin%20monitoring%20systems%0A-%20Computer%20vision%20safety%20systems%0A-%20IoT-connected%20field%20intelligence%20systems%0A-%20XR%20and%20simulation%20training%20platforms%0A-%20Agentic%20AI%20and%20RAG-based%20knowledge%20systems%0A-%20Workflow%20automation%20and%20decision%20intelligence%20dashboards%0A%0ACould%20one%20of%20your%20technology%20consultants%20connect%20with%20me%20to%20understand%20our%20requirements%20and%20explore%20how%20NGXP%20Technologies%20can%20support%20our%20business%3F%0A%0AThank%20you",
      },
    ],
  },
};

function buildLookup(sections) {
  const map = {};
  for (const s of sections) map[s.key] = s;
  const get = (key, field, fallback) => {
    const s = map[key];
    if (!s) return fallback;
    const v = s.content?.[field];
    if (v === undefined || v === null) return fallback;
    if (typeof v === "string" && v.trim() === "") return fallback;
    if (Array.isArray(v) && v.length === 0) return fallback;
    return v;
  };
  const enabled = (key) => {
    if (Object.keys(map).length === 0) return true; // fallback when API empty
    return !!map[key]?.enabled;
  };
  return { get, enabled };
}

// Addresses may be stored as a string with newlines or as a list of lines.
const toLines = (value) =>
  (Array.isArray(value) ? value : String(value || "").split("\n")).filter(
    (l) => String(l).trim() !== ""
  );

const isInternal = (href) => typeof href === "string" && href.startsWith("/");

export default function Footer() {
  const [sections, setSections] = useState([]);

  useEffect(() => {
    axios
      .get(`${API}/pages/footer/sections`)
      .then(({ data }) => {
        if (Array.isArray(data)) setSections(data);
      })
      .catch(() => {});
  }, []);

  const { get, enabled } = buildLookup(sections);
  const F = FALLBACK;

  const brand = {
    logo: get("brand", "logo_url", F.brand.logo_url),
    logoAlt: get("brand", "logo_alt", F.brand.logo_alt),
    desc: get("brand", "description", F.brand.description),
    officeLabel: get("brand", "office_label", F.brand.office_label),
    officeLines: toLines(get("brand", "office_address", F.brand.office_address)),
    ctaLabel: get("brand", "cta_label", F.brand.cta_label),
    ctaLink: get("brand", "cta_link", F.brand.cta_link),
  };

  const explore = {
    heading: get("explore", "heading", F.explore.heading),
    links: (get("explore", "links", F.explore.links) || []).filter((l) => l?.label),
  };

  const contact = {
    heading: get("contact", "heading", F.contact.heading),
    addresses: toLines(get("contact", "addresses", F.contact.addresses)),
    email: get("contact", "email", F.contact.email),
    phone: get("contact", "phone", F.contact.phone),
    websiteLabel: get("contact", "website_label", F.contact.website_label),
    websiteLink: get("contact", "website_link", F.contact.website_link),
  };

  const bottom = {
    sealImage: get("bottom", "seal_image", F.bottom.seal_image),
    sealLink: get("bottom", "seal_link", F.bottom.seal_link),
    sealAlt: get("bottom", "seal_alt", F.bottom.seal_alt),
    copyright: String(get("bottom", "copyright", F.bottom.copyright)).replace(
      /\{year\}/g,
      new Date().getFullYear()
    ),
    tagline: get("bottom", "tagline", F.bottom.tagline),
    socials: (get("bottom", "socials", F.bottom.socials) || []).filter(
      (s) => s?.href && SOCIAL_PATHS[String(s.platform || "").toLowerCase()]
    ),
  };

  const addressIconColors = ["#FF007F", "#7B2CBF"];

  return (
    <footer className="bg-[#0A0B10] text-white relative overflow-hidden" data-testid="site-footer">
      <div className="absolute inset-0 dark-grid-pattern opacity-40 pointer-events-none" />
      <div className="glow-blob bg-[#7B2CBF]/20 w-[500px] h-[500px] -top-40 -left-40" />
      <div className="glow-blob bg-[#00A8E8]/20 w-[400px] h-[400px] -bottom-20 -right-20" />

      <div className="container-ngxp relative z-10 py-16 md:py-20">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 md:gap-12">
          {/* Brand */}
          {enabled("brand") && (
            <div className="md:col-span-5">
              <Link to="/" className="inline-flex items-center" data-testid="footer-logo">
                <img src={brand.logo} alt={brand.logoAlt} className="h-36 md:h-44 w-auto object-contain" />
              </Link>
              {brand.desc && (
                <p className="mt-5 text-white/60 text-sm leading-relaxed max-w-md">{brand.desc}</p>
              )}
              {brand.officeLines.length > 0 && (
                <div className="mt-6 space-y-4 text-sm text-white/70 max-w-md">
                  <div>
                    {brand.officeLabel && (
                      <p className="text-xs font-semibold uppercase tracking-[0.18em] text-white/45">
                        {brand.officeLabel}
                      </p>
                    )}
                    <p className="mt-1 leading-relaxed">
                      {brand.officeLines.map((line, i) => (
                        <span key={i}>
                          {line}
                          {i < brand.officeLines.length - 1 && <br />}
                        </span>
                      ))}
                    </p>
                  </div>
                </div>
              )}
              {brand.ctaLabel && (
                <Link
                  to={brand.ctaLink}
                  data-testid="footer-cta"
                  className="mt-7 inline-flex items-center gap-1.5 btn-primary-gradient"
                >
                  {brand.ctaLabel} <ArrowUpRight className="w-4 h-4" />
                </Link>
              )}
            </div>
          )}

          {/* Navigation */}
          {enabled("explore") && (
            <div className="md:col-span-3">
              <h4 className="text-sm font-semibold uppercase tracking-[0.2em] text-white/50 mb-4">
                {explore.heading}
              </h4>
              <ul className="space-y-3 text-sm">
                {explore.links.map((l) => {
                  const testId = `footer-link-${String(l.label).toLowerCase().replace(/\s+/g, "-")}`;
                  const cls =
                    "text-white/70 hover:text-white transition-colors inline-flex items-center gap-1";
                  return (
                    <li key={`${l.to}-${l.label}`}>
                      {isInternal(l.to) ? (
                        <Link to={l.to} className={cls} data-testid={testId}>
                          {l.label}
                        </Link>
                      ) : (
                        <a href={l.to} target="_blank" rel="noreferrer" className={cls} data-testid={testId}>
                          {l.label}
                        </a>
                      )}
                    </li>
                  );
                })}
              </ul>
            </div>
          )}

          {/* Contact */}
          {enabled("contact") && (
            <div className="md:col-span-4">
              <h4 className="text-sm font-semibold uppercase tracking-[0.2em] text-white/50 mb-4">
                {contact.heading}
              </h4>
              <ul className="space-y-4 text-sm text-white/70">
                {contact.addresses.map((addr, i) => (
                  <li key={i} className="flex gap-3">
                    <MapPin
                      className="w-4 h-4 mt-0.5 shrink-0"
                      style={{ color: addressIconColors[i % addressIconColors.length] }}
                    />
                    <span>{addr}</span>
                  </li>
                ))}
                {contact.email && (
                  <li className="flex gap-3">
                    <Mail className="w-4 h-4 mt-0.5 text-[#00A8E8] shrink-0" />
                    <a href={`mailto:${contact.email}`} className="hover:text-white transition-colors">
                      {contact.email}
                    </a>
                  </li>
                )}
                {contact.phone && (
                  <li className="flex gap-3">
                    <Phone className="w-4 h-4 mt-0.5 text-[#00A8E8] shrink-0" />
                    <span>{contact.phone}</span>
                  </li>
                )}
                {contact.websiteLabel && (
                  <li className="flex gap-3">
                    <Globe className="w-4 h-4 mt-0.5 text-[#7B2CBF] shrink-0" />
                    <a
                      href={contact.websiteLink}
                      target="_blank"
                      rel="noreferrer"
                      className="hover:text-white transition-colors"
                    >
                      {contact.websiteLabel}
                    </a>
                  </li>
                )}
              </ul>
            </div>
          )}
        </div>

        {enabled("bottom") && (
          <div className="mt-14 pt-8 border-t border-white/10 flex flex-col md:flex-row gap-6 justify-between items-center text-xs text-white/50">
            <div className="flex flex-col sm:flex-row items-center gap-4">
              {/* D&B D-U-N-S Registered™ Seal — official Key1 profile link (new tab) */}
              {bottom.sealImage && (
                <a
                  href={bottom.sealLink}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="View NGXP TECHNOLOGIES LLP D-U-N-S Registered profile"
                  data-testid="duns-seal"
                  className="shrink-0 inline-block rounded-sm bg-white p-1.5 hover:opacity-90 transition-opacity"
                  title="D-U-N-S Registered — NGXP TECHNOLOGIES LLP"
                >
                  <img
                    src={bottom.sealImage}
                    alt={bottom.sealAlt}
                    width={97}
                    height={97}
                    className="block w-[97px] h-[97px] object-contain"
                  />
                </a>
              )}
              <p>{bottom.copyright}</p>
            </div>

            {/* Social Icons */}
            <div className="flex items-center gap-3">
              {bottom.socials.map(({ href, platform }) => (
                <a
                  key={`${platform}-${href}`}
                  href={href}
                  target="_blank"
                  rel="noreferrer"
                  aria-label={platform}
                  className="w-8 h-8 rounded-full bg-white/10 hover:bg-white/20 flex items-center justify-center transition-colors"
                >
                  <svg viewBox="0 0 24 24" fill="currentColor" className="w-4 h-4 text-white/70 hover:text-white">
                    <path d={SOCIAL_PATHS[String(platform).toLowerCase()]} />
                  </svg>
                </a>
              ))}
            </div>

            {bottom.tagline && <p className="font-display tracking-wide">{bottom.tagline}</p>}
          </div>
        )}
      </div>
    </footer>
  );
}
